import { render } from "./Callback.vue?vue&type=template&id=1355e1c3"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__